// extracted by mini-css-extract-plugin
module.exports = {"excerpt":"styles_excerpt__1BS81","category":"styles_category__17sfo","image":"styles_image__2L7ND","thumbnailMoreButtonContainer":"styles_thumbnailMoreButtonContainer__3n4fc"};